function getVariantIdFromUrlDesc() {
  const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  });
  let variant_id = params.variant;
  return variant_id;
}

function checkForUrlChangeDesc() {

  if (typeof URLCheckCurrentVariantIdDesc === 'undefined') {
    // console.warn('You are on free plan');
    window.URLCheckCurrentVariantIdDesc = null;
  }

  const newVariantId = getVariantIdFromUrlDesc();
  if (newVariantId !== URLCheckCurrentVariantIdDesc) {
    URLCheckCurrentVariantIdDesc = newVariantId == null ?  URLCheckCurrentVariantIdDesc : newVariantId;
    if (typeof handleVariantChangeDesc === 'function') {
      handleVariantChangeDesc();
    } 
    // else {
    //   console.warn('handleVariantChangeDesc is not defined.');
    // }
    return true;
  }
  return false;
}

function monitorUrlChangeWithTimeoutDesc() {
  const timeout = 20000;
  const interval = 100;
  let elapsedTime = 0;
  let checkInterval;

  return new Promise((resolve, reject) => {
    function check() {
      if (checkForUrlChangeDesc()) {
        clearInterval(checkInterval);
        resolve();
      } else if (elapsedTime >= timeout) {
        clearInterval(checkInterval);
        reject('Slow Network Error');
      } else {
        elapsedTime += interval;
      }
    }
    checkInterval = setInterval(check, interval);
  });
}

document.addEventListener('change', () => {
  monitorUrlChangeWithTimeoutDesc()
    .then(() => {
      console.log('Variant description changed and handled.');
    })
    .catch((error) => {
      console.error(error);
    });
});